import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store/store';

import Alerts from '../components/Alerts';

const withStorePublicInfo = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const WithStoreInfo: React.FC<P> = (props) => {
    const { storeInfo } = useSelector((state: RootState) => state.products);
    const { storeId } = useSelector((state: RootState) => state.setup);

    useEffect(() => {
      if (storeInfo && storeInfo.email) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const kv: [string, any][] = [
          ['coverImage', storeInfo.coverImage],
          ['email', storeInfo.email],
          ['storeId', storeId],
          ['faviconUrl', storeInfo.faviconUrl],
          ['isMimicEnabled', storeInfo.isMimicEnabled],
          ['isStorefrontLoginEnabled', !storeInfo.isStorefrontLoginDisabled],
          [
            'isStorefrontMimicOnlyModeEnabled',
            storeInfo.isStorefrontMimicOnlyModeEnabled,
          ],
          ['isPickupEnabled', storeInfo.isPickupEnabled],
          ['isDeliveryEnabled', storeInfo.isDeliveryEnabled],
          ['isStorefrontEnabled', storeInfo.isStorefrontEnabled],
          ['logoUrl', storeInfo.logoUrl],
          ['mimicWhatsAppPhoneNumber', storeInfo.mimicWhatsAppPhoneNumber],
          ['name', storeInfo.name],
          ['phoneNumber', storeInfo.phoneNumber],
        ];
        document.title = storeInfo.name;
        const link = document.createElement('link');
        link.id = 'favicon';
        link.rel = 'icon';
        link.href = storeInfo?.faviconUrl || '';
        document.head.appendChild(link);

        kv.forEach(([key, value]) => {
          localStorage.removeItem(key);
          if (typeof value !== 'undefined' && value !== null) {
            const toStore =
              typeof value === 'object' ? JSON.stringify(value) : String(value);
            if (value) {
              localStorage.setItem(key, toStore);
            }
          }
        });
      }
    }, [storeInfo, storeId]);

    if (storeInfo === undefined) {
      return (
        <div>
          <Alerts message="Loading store items..." />
        </div>
      );
    }
    if (storeInfo === null) {
      return <Alerts message="Store not found..." />;
    }

    if (storeInfo && Object.keys(storeInfo).length > 0) {
      return <WrappedComponent {...(props as P)} />;
    }
  };
  return WithStoreInfo;
};

export default withStorePublicInfo;
